export interface Author {
  name: string;
  avatar?: string;
  role?: string;
}

export interface BlogImage {
  src: string;
  alt: string;
}

export type BlogCategory =
  | 'holdings-patrimoniais'
  | 'planejamento-sucessorio'
  | 'contabilidade'
  | 'tributacao'
  | 'dicas';

export interface BlogFrontmatter {
  title: string;
  description: string;
  publishDate: string;
  updatedDate?: string;
  author: Author;
  category: BlogCategory;
  tags: string[];
  image: BlogImage;
  draft: boolean;
  featured: boolean;
}

export interface BlogPost {
  slug: string;
  frontmatter: BlogFrontmatter;
  content: string;
}

export const categoryLabels: Record<BlogCategory, string> = {
  'holdings-patrimoniais': 'Holdings Patrimoniais',
  'planejamento-sucessorio': 'Planejamento Sucessório',
  contabilidade: 'Contabilidade',
  tributacao: 'Tributação',
  dicas: 'Dicas',
};
